// @ts-nocheck

export const SPORTS_MENU_LIST_ITEM_HEIGHT = 3.3; // em
export const SPORTS_MENU_LIST_ITEM_BORDER_RADIUS = 15; // px
